module.exports = __webpack_public_path__ + "img/product10.a271912f.jpg";